import { mapState, mapActions } from 'vuex';

export default {
  props: {
    value: {
      require: false,
      default: '',
    },
    maxLength: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState('trade', ['keyboardDoubleSelected']),
    text() {
      return String(isNaN(this.value) || this.value === null ? '' : this.value);
    },
  },
  methods: {
    ...mapActions('trade', ['updateKeyboardDoubleSelected']),
    buttonClick(numberChar) {
      if (this.keyboardDoubleSelected) {
        this.updateKeyboardDoubleSelected(false);
        this.$emit('input', Number(numberChar));
        return;
      }
      if (numberChar === '0' && this.text === '') {
        return;
      }
      if (this.maxLength && this.maxLength <= this.text.length) {
        return;
      }
      const text = this.text + numberChar;
      this.$emit('input', Number(text));
    },
    backspaceClick() {
      if (this.keyboardDoubleSelected) {
        this.updateKeyboardDoubleSelected(false);
        this.$emit('input', null);
        return;
      }
      if (this.text.length > 0) {
        const text = this.text.substring(0, this.text.length - 1);
        if (text.length > 0) {
          this.$emit('input', Number(text));
        } else {
          this.$emit('input', null);
        }
      }
    },
    outsideClick() {
      this.$emit('outsideClick');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/keyboard-numeric/keyboard-numeric.js